import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import './TopBar.css';
import { useSelector } from 'react-redux';

const TopBar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const eventData = useSelector((state) => state.event.eventData);

  const toggleMobileMenu = () => setMobileMenuOpen(!isMobileMenuOpen);

  return (
    <header className="th-header header-layout3 header-absolute">
      <div className="sticky-wrapper">
        <div className="menu-area">
          <div className="container">
            {/* Desktop View */}
            <div className="topbar-desktop">
              <nav className="main-menu">
                <ul className="menu-list">
                  <li><Link className="active" to="/">Home</Link></li>
                  <li><Link to="/video">Video</Link></li>
                  <li><Link to="/event">Events</Link></li>
                </ul>
              </nav>

              <Link to="/" className="logo">
                <img
                  src={eventData.customization?.imageKey}
                  alt="Logo"
                  style={{ height: "60px" }}
                />
              </Link>

              <nav className="main-menu">
                <ul className="menu-list">
                  <li><Link to="/community">Community</Link></li>
                  <li><Link to="/news">News</Link></li>
                  <li><Link to="/contact">Contact Us</Link></li>
                </ul>
              </nav>

              {/* Mobile Menu Icon */}
              <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
                {isMobileMenuOpen ? <CloseIcon /> : <MenuIcon />}
              </div>
            </div>

            {/* Mobile View */}
            {isMobileMenuOpen && (
              <div className="mobile-menu">
                <ul className="mobile-menu-list">
                  <li><Link to="/" onClick={toggleMobileMenu}>Home</Link></li>
                  <li><Link to="/video" onClick={toggleMobileMenu}>Video</Link></li>
                  <li><Link to="/event" onClick={toggleMobileMenu}>Events</Link></li>
                  <li><Link to="/community" onClick={toggleMobileMenu}>Community</Link></li>
                  <li><Link to="/news" onClick={toggleMobileMenu}>News</Link></li>
                  <li><Link to="/contact" onClick={toggleMobileMenu}>Contact Us</Link></li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
